export default "__VITE_ASSET__242f3d0e__"